import { HttpClient } from '@angular/common/http';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
var HomeService = /** @class */ (function () {
    function HomeService(http) {
        this.http = http;
        this.serverUrl = environment.serverUrl;
    }
    HomeService.prototype.categoriesListing = function () {
        var reqObj = "categories/all";
        return this.http.get(this.serverUrl + reqObj);
    };
    HomeService.prototype.featuredImages = function () {
        var reqObj = 'featureimages/active';
        return this.http.get(this.serverUrl + reqObj);
    };
    HomeService.prototype.featuredImagesAndCategories = function (date) {
        var reqObj = 'categories/withactivefeatures';
        return this.http.put(this.serverUrl + reqObj, { date: date });
    };
    return HomeService;
}());
export { HomeService };



// WEBPACK FOOTER //
// ./src/app/services/home.service.ts.pre-build-optimizer.js